import TestPaper from './src/components/TestPaper.vue'
import TestPaper2 from './src/components/TestPaper2.vue'
import { tags } from './src/constant/tags'

export { TestPaper, TestPaper2, tags }
